import { Tkv2PairedCostSummaryInterfaceV2 } from '../../types.ts';
import { AdjustmentBreakdownAdditionalStructure } from './AdjustmentBreakdownAdditionalStructure.tsx';

export const AdjustmentBreakdownAdditionalStructureBarn = (
  props: Tkv2PairedCostSummaryInterfaceV2,
) => (
  <AdjustmentBreakdownAdditionalStructure
    {...props}
    breakdownCategory="barn"
    title="Barn"
    id="isDepreciatedCostAdditionalImprovementsBarnInExport"
    summary={props}
  />
);
